import React, { useMemo } from 'react';
import { array, bool, node, object, string } from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { mergeArrays } from '../../../util/misc';
import { ListingCard, PaginationLinks } from '../../../components';
import { buildSameTyreGroups } from '../resultCardData';

import css from './SearchResultsPanel.module.css';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    adverts,
    pagination,
    search,
    setActiveListing,
    isMapVariant,
    removeAds,
    isCustom,
    viewMode = 'grid',
    searchOrigin = null,
  } = props;
  const isList = viewMode === 'list';
  const classes = classNames(rootClassName || css.root, className);

  /* "Samma däck från N säljare — från X kr/st" (P25009-445 BR-6): same
   * product, different sellers, grouped over the loaded page. */
  const sameTyreGroups = useMemo(() => buildSameTyreGroups(listings), [listings]);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  const cardRenderSizes = isMapVariant => {
    if (isMapVariant) {
      // Panel width relative to the viewport
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 767px) 100vw',
        `(max-width: 1023px) ${panelMediumWidth}vw`,
        `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
        `${panelLargeWidth / 3}vw`,
      ].join(', ');
    } else {
      // Panel width relative to the viewport
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 549px) 100vw',
        '(max-width: 767px) 50vw',
        `(max-width: 1439px) 26vw`,
        `(max-width: 1920px) 18vw`,
        `14vw`,
      ].join(', ');
    }
  };

  const mergedItems = removeAds ? listings : mergeArrays(listings, adverts, 4);

  return (
    <div className={classes}>
      <div
        className={
          isMapVariant
            ? css.listingCardsMapVariant
            : isCustom
              ? css.customCarousel
              : isList
                ? css.listingCardsList
                : css.listingCards
        }
      >
        {mergedItems.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={cardRenderSizes(isMapVariant)}
            setActiveListing={setActiveListing}
            showFavoriteIcons={true}
            isCustom={isCustom}
            layout={!isMapVariant && !isCustom ? viewMode : 'grid'}
            searchOrigin={searchOrigin}
            sameTyreGroup={sameTyreGroups[l.id.uuid] || null}
          />
        ))}
        {props.children}
      </div>
      {/* {paginationLinks} */}
      {!isCustom && paginationLinks}
    </div>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  pagination: null,
  rootClassName: null,
  search: null,
  isMapVariant: true,
};

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
  isMapVariant: bool,
};

export default SearchResultsPanel;
